<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="eSIM供应商">
            <a-select
              v-decorator="['esim_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingProducerOptions"
            >
              <a-select-option
                v-for="opt in producerOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="SGP规范">
            <a-select
              mode="multiple"
              v-decorator="['sgp_spec_ids']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingSgpSpecOptions"
            >
              <a-select-option
                v-for="opt in sgpSpecOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="LPA/IPA">
            <a-select
              v-decorator="['lpa_ipa_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingLpaIpaOptions"
            >
              <a-select-option
                v-for="opt in lpaIpaOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="是否有预制号">
            <a-select
              v-decorator="['has_preconfigured_number']"
              allow-clear
              placeholder="请选择"
            >
              <a-select-option key="1" value="1">
                是
              </a-select-option>
              <a-select-option key="0" value="0">
                否
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="eIM平台">
            <a-select
              v-decorator="['eim_platform_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingEimPlatformOptions"
            >
              <a-select-option
                v-for="opt in eimPlatformOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="卡片材质">
            <a-select
              v-decorator="['card_type_id']"
              allow-clear
              placeholder="请选择"
              :loading="loadingCardTypeOptions"
              @change="handleCardTypeChange"
            >
              <a-select-option
                v-for="opt in cardTypeOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="卡片尺寸">
            <a-select
              v-decorator="['card_shape_name']"
              allow-clear
              placeholder="请先选择材质"
              :loading="loadingCardShapeOptions"
            >
              <a-select-option
                v-for="opt in cardShapeOptions"
                :key="opt.name"
                :value="opt.name"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="库房位置">
            <a-select
              v-decorator="['warehouse_location_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingWarehouseOptions"
            >
              <a-select-option
                v-for="opt in warehouseOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="EID">
            <a-input
              v-decorator="['eid', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="生产批次">
            <a-input
              v-decorator="['production_batch', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findEsimSuppliers } from '@/api/esim_supplier'
import { findCardTypeOptions, findCardShapeOptions } from '@/api/common_options'

export default {
  name: 'SearchEsimInventory',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'esim_inventory_search' }),
      producerOptions: [],
      sgpSpecOptions: [],
      lpaIpaOptions: [],
      eimPlatformOptions: [],
      cardTypeOptions: [],
      cardShapeOptions: [],
      warehouseOptions: [],
      loadingProducerOptions: false,
      loadingSgpSpecOptions: false,
      loadingLpaIpaOptions: false,
      loadingEimPlatformOptions: false,
      loadingCardTypeOptions: false,
      loadingCardShapeOptions: false,
      loadingWarehouseOptions: false
    }
  },
  created() {
    this.fetchProducerOptions()
    this.fetchSgpSpecOptions()
    this.fetchLpaIpaOptions()
    this.fetchEimPlatformOptions()
    this.fetchCardTypeOptions()
    this.fetchWarehouseOptions()
  },
  methods: {
    fetchProducerOptions() {
      this.loadingProducerOptions = true
      findEsimSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data
        }
        this.loadingProducerOptions = false
      })
    },

    fetchSgpSpecOptions() {
      this.loadingSgpSpecOptions = true
      findCommonTypeOptions('product_esim_sgp_spec').then((res) => {
        if (res.code === 0) {
          this.sgpSpecOptions = res.data
        }
        this.loadingSgpSpecOptions = false
      })
    },

    fetchLpaIpaOptions() {
      this.loadingLpaIpaOptions = true
      findCommonTypeOptions('product_esim_lpa_ipa').then((res) => {
        if (res.code === 0) {
          this.lpaIpaOptions = res.data
        }
        this.loadingLpaIpaOptions = false
      })
    },

    fetchEimPlatformOptions() {
      this.loadingEimPlatformOptions = true
      findCommonTypeOptions('eim_platform').then((res) => {
        if (res.code === 0) {
          this.eimPlatformOptions = res.data
        }
        this.loadingEimPlatformOptions = false
      })
    },

    fetchCardTypeOptions() {
      this.loadingCardTypeOptions = true
      findCardTypeOptions().then((res) => {
        if (res.code === 0) {
          this.cardTypeOptions = res.data
        }
        this.loadingCardTypeOptions = false
      })
    },

    fetchWarehouseOptions() {
      this.loadingWarehouseOptions = true
      findCommonTypeOptions('warehouse_location').then((res) => {
        if (res.code === 0) {
          this.warehouseOptions = res.data
        }
        this.loadingWarehouseOptions = false
      })
    },

    handleCardTypeChange(cardTypeId) {
      this.form.setFieldsValue({ card_shape_name: undefined })
      this.cardShapeOptions = []
      if (!cardTypeId) {
        return
      }
      this.loadingCardShapeOptions = true
      findCardShapeOptions(cardTypeId).then((res) => {
        if (res.code === 0) {
          this.cardShapeOptions = res.data
        }
        this.loadingCardShapeOptions = false
      })
    },

    buildSearchParams(values) {
      const search = {}
      Object.keys(values || {}).forEach((key) => {
        const value = values[key]
        if (value === undefined || value === null || value === '') {
          return
        }
        if (Array.isArray(value) && value.length === 0) {
          return
        }
        search[key] = value
      })
      return search
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.buildSearchParams(this.form.getFieldsValue()))
    },

    handleReset() {
      this.form.resetFields()
      this.cardShapeOptions = []
      this.$emit('submit', {})
    }
  }
}
</script>
